import { useDataStore, useFilterStore } from "@/stores";
import clsx from "clsx";
import { forwardRef, useImperativeHandle } from "react";

interface ClassificationFilterProps {
    shouldConfirm?: boolean;
    small?: boolean;
}

export interface ClassificationFilterRef {
    confirmChange: () => void;
}

const ClassificationFilter = forwardRef<ClassificationFilterRef, ClassificationFilterProps>(
    ({ shouldConfirm, small }, ref) => {
        const classifications = useDataStore((state) => state.classifications);
        const activeVersion = useFilterStore((state) => state.activeModalVersion);
        const activeClassification = useFilterStore((state) => state.activeClassification);
        const setActiveClassification = useFilterStore((state) => state.setActiveClassification);
        const unconfirmedClassification = useFilterStore((state) => state.unconfirmedClassification);
        const setUnconfirmedClassification = useFilterStore((state) => state.setUnconfirmedClassification);

        useImperativeHandle(ref, () => ({
            confirmChange: () => {
                setActiveClassification(unconfirmedClassification);
            },
        }));

        if (!classifications[activeVersion!]) return null;

        return classifications[activeVersion!]
            .filter((x) => x.active)
            .sort((a, b) => a.order - b.order)
            .map((classification) => {
                const id = `classification-${shouldConfirm ? "confirm" : "direct"}-${classification.id}`;
                const isActive = activeClassification === classification.id;
                const isUnconfirmed = unconfirmedClassification === classification.id;
                const isSelected = shouldConfirm ? isUnconfirmed : isActive;

                const handleClick = () => {
                    if (shouldConfirm) {
                        setUnconfirmedClassification(
                            unconfirmedClassification === classification.id ? null : classification.id
                        );
                    } else {
                        setActiveClassification(activeClassification === classification.id ? null : classification.id);
                    }
                };

                return (
                    <div key={classification.id} className="group">
                        <div
                            className={clsx([
                                "flex flex-wrap rounded-md text-base font-medium items-center cursor-pointer",
                                small ? "min-h-14 gap-3 px-5 py-3" : "min-h-[90px] gap-3 p-5",
                                // "hover:bg-primary-600 hover:text-white",
                                // "group-has-checked:bg-primary-500 group-has-checked:text-white",
                                "bg-primary-100 text-primary-500 hover:bg-primary-600 group-has-checked:bg-primary-500",
                                "hover:text-white group-has-checked:text-white",
                            ])}
                            onClick={handleClick}
                        >
                            <div className="grid size-6 grid-cols-1 shrink-0">
                                <input
                                    id={id}
                                    name={id}
                                    value={classification.id}
                                    type="radio"
                                    checked={isSelected}
                                    onChange={() => {}}
                                    className={clsx([
                                        " cursor-pointer col-start-1 row-start-1 appearance-none rounded-full border-2 min-w-6 min-h-6",
                                        "checked:outline-2 checked:-outline-offset-4",
                                        "border-primary-300 bg-primary-100 checked:outline-primary-500",
                                    ])}
                                />
                                <div className="pointer-events-none opacity-0 group-has-checked:opacity-100 bg-white w-4 h-4 rounded-full col-start-1 row-start-1 self-center justify-self-center" />
                                <div
                                    className={clsx([
                                        "pointer-events-none opacity-0 group-has-checked:opacity-100  w-3 h-3 rounded-full col-start-1 row-start-1 self-center justify-self-center",
                                        "bg-primary-500",
                                    ])}
                                />
                            </div>

                            {classification.name}
                        </div>
                    </div>
                );
            });
    }
);

export default ClassificationFilter;